import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/** Preserve colour and size across the paired front/back products. */
class KredPlacement extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.updateSelection, { signal: this.controller.signal });
    const picker = this.section?.querySelector('variant-picker');
    if (picker && this.nextElementSibling !== picker) picker.before(this);
    this.stampForms();
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  updateSelection = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const selection = this.selection = event.promise;
    try {
      const { detail } = await selection;
      if (!this.isConnected || selection !== this.selection || String(detail?.productId) !== this.dataset.productId) return;
      const fresh = detail?.html?.querySelector(`kred-placement[data-product-id="${this.dataset.productId}"]`);
      if (!fresh) return;
      for (const link of this.querySelectorAll('[data-print-side]')) {
        const next = fresh.querySelector(`[data-print-side="${link.dataset.printSide}"]`);
        if (next) link.setAttribute('href', next.getAttribute('href'));
      }
      this.stampForms();
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('Print placement selection could not refresh.');
    }
  };

  stampForms() {
    if (!this.dataset.placement) return;
    for (const form of this.section?.querySelectorAll('form[action*="/cart/add"]') ?? []) {
      let input = form.querySelector('input[name="properties[Print placement]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Print placement]';
        form.append(input);
      }
      input.value = this.dataset.placement;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.selection = undefined;
  }
}

if (!customElements.get('kred-placement')) customElements.define('kred-placement', KredPlacement);
